import { DevIndexPage } from '@jusbrasil-web/core-next'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import styles from './index.module.scss'

export function IndexPage(_props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <DevIndexPage
      title="Auth"
      subtitle="Jusbrasil authentication and registration application"
      pages={{
        '/login': 'Login',
        '/recuperar-senha': 'Password Recovery',
        '/configuracoes/alterar-senha': 'Change Password',
        '/configuracoes/alterar-email': 'Change Email',
        '/sso/erro': 'SSO Error',
      }}
      metadata={{
        Team: '@growth-trust-identity-devs',
        Channel: '#team-growth-trust-identity-dev',
      }}
      className={styles.container}
    />
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  return {
    props: { ...withUserSession(ctx) },
  }
}

export const IndexPageExports = { getServerSideProps }
